import { AuthProvider } from '@sdk/authentication/AuthContext';
import { AuthUserType } from '@sdk/authentication/types/AuthUserType';

import { ShiftsBridgeState } from '@web/shifts/shiftsBridgeProvider.types';
import { ShiftsBridgeProvider } from '@web/shifts/ShiftsBridgeProvider';

import r2a from '../../angularIntegration/r2a';

import { ProjectedSalesImportButton, Props as ButtonProps } from './Button';

type Props = {
  currentUser: AuthUserType;
  shiftsReactBridge: ShiftsBridgeState;
} & ButtonProps;

const Button = ({ shiftsReactBridge, currentUser, ...buttonProps }: Props) => (
  <AuthProvider currentUser={currentUser}>
    <ShiftsBridgeProvider bridge={shiftsReactBridge}>
      <ProjectedSalesImportButton {...buttonProps} />
    </ShiftsBridgeProvider>
  </AuthProvider>
);

export const rProjectedSalesImportButton = r2a({
  ReactComponent: Button,
  bindings: {
    currentUser: '<',
    days: '<',
    locationIds: '<',
    totalProjectedSales: '<',
    importedAt: '<',
    shiftsReactBridge: '<',
  },
});
